<template>
  <div id="home">
    <div
      :style="{
        height: `${phoneSearchHeight}px`
      }"
    />
    <Banner />

    <el-row class="container">
      <el-col
        v-show="innerWidthType !== 'xs' && topItemImg && topItemFont"
        ref="contentOne"
        :span="22"
        class="container-items"
      >
        <!-- <div
          class="play-icon-class"
          @click="openVideo"
        >
          <i class="el-icon-video-play play-icon-item-class" />
        </div> -->
        <el-image
          style="
            position: absolute;
            right: 0;
            top: 0;
            width: 23%;
            cursor: pointer;
            border-radius: 15px;
          "
          :src="require('@/assets/images/12years.jpg')"
          alt="和顺堂12周年"
          @click="openVideo"
        />
        <el-col
          v-if="topItemImg"
          ref="contentOneImg"
          :span="18"
          class="container-items-img"
        >
          <el-image
            :src="topItemImg"
            alt="精品中药"
            :preview-src-list="[topItemImg]"
          />
        </el-col>
        <el-col
          v-if="topItemFont"
          ref="contentOneInfo"
          :span="15"
          class="container-items-font"
        >
          <span>{{ topItemFont.main }}</span>
          <div class="container-items-font-title">{{ topItemFont.title }}</div>
          <div
            v-for="(item, index) in topItemFont.content"
            :key="index"
            class="container-items-font-content"
          >
            {{ item }}
          </div>
        </el-col>
      </el-col>

      <el-col
        v-show="innerWidthType === 'xs' && topItemImg && topItemFont"
        :span="22"
        class="container-items"
        style="margin-bottom: 30px;"
      >
        <el-col v-if="topItemImg" :span="24" class="container-items-img" style="position: relative; top: 0; left: 0;">
          <el-image
            :src="require('@/assets/images/12yearsbanner.jpg')"
            alt="和顺堂12周年"
            class="container-items-img"
            @click="openVideo"
          />
          <!-- <div style="position: absolute; bottom: 0; left: 0; color: #fff; padding: 5px; font-size: 35px; font-weight: bold;">
            <i class="el-icon-video-play" />
          </div> -->
        </el-col>
      </el-col>

      <el-col
        v-show="innerWidthType === 'xs' && topItemImg && topItemFont"
        :span="22"
        class="container-items"
      >
        <el-col v-if="topItemImg" :span="24" class="container-items-img">
          <el-image
            :src="topItemImg"
            alt="精品中药"
            :preview-src-list="[topItemImg]"
          />
        </el-col>
        <el-col
          v-if="topItemFont"
          :span="24"
          class="container-items-font-phone"
        >
          <span>{{ topItemFont.main }}</span>
          <div class="container-items-font-title">{{ topItemFont.title }}</div>
          <div
            v-for="(item, index) in topItemFont.content"
            :key="index"
            class="container-items-font-content"
          >
            {{ item }}
          </div>
        </el-col>
      </el-col>

      <el-col
        v-if="
          innerWidthType !== 'xs' &&
            innerWidthType !== 'sm' &&
            innerWidthType !== 'md'
        "
        :span="22"
        class="container-nine-grid"
      >
        <div
          v-for="(item, index) in nineGridData"
          :key="index"
          class="container-items-img"
        >
          <el-image :src="item.img" alt="" lazy />
          <div class="info">
            <span class="info-ch" v-html="item.infoCh" />
            <span class="info-en">{{ item.infoEn }}</span>
            <span class="info-detail">
              <div v-for="(deItem, deIndex) in item.infoDetail" :key="deIndex">
                <div class="title">{{ deItem.title }}</div>
                <div class="content">{{ deItem.content }}</div>
              </div>
            </span>
            <div class="shadow" />
          </div>
        </div>
      </el-col>
      <el-col v-else :span="22" class="container-nine-grid">
        <el-col v-if="nineGridData" :span="24">
          <el-carousel
            :interval="4000"
            type="card"
            :height="`${litterHeight}px`"
          >
            <el-carousel-item
              v-for="(item, index) in nineGridData"
              :key="index"
            >
              <div class="container-items-img">
                <el-image ref="litterImg" :src="item.img" alt="" />
                <div class="info" @click="setShadow(index)">
                  <div
                    v-if="!item.showDetail"
                    class="info-ch"
                    v-html="item.infoCh"
                  />
                  <div v-if="!item.showDetail" class="info-en">
                    {{ item.infoEn }}
                  </div>
                  <div v-if="item.showDetail" class="info-detail">
                    <div
                      v-for="(deItem, deIndex) in item.infoDetail"
                      :key="deIndex"
                      @click.stop="setShadow(index)"
                    >
                      <div class="title">{{ deItem.title }}</div>
                      <div class="content">{{ deItem.content }}</div>
                    </div>
                  </div>
                  <div v-if="item.isShadow" class="shadow" />
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </el-col>
      </el-col>

      <el-col
        v-show="innerWidthType !== 'xs' && bottomItemImg && bottomItemFont"
        ref="contentTwo"
        :span="22"
        class="container-items"
      >
        <el-col
          v-if="bottomItemImg"
          ref="contentTwoImg"
          :span="18"
          class="container-items-img"
        >
          <el-image
            :src="bottomItemImg"
            alt="公司简介中药团队"
            :preview-src-list="[bottomItemImg]"
            lazy
          />
        </el-col>
        <el-col
          v-if="bottomItemFont"
          ref="contentTwoInfo"
          :span="13"
          class="container-items-font"
        >
          <div v-for="(item, index) in bottomItemFont" :key="index" class="bM">
            <span>{{ item.main }}</span>
            <div class="container-items-font-content">{{ item.content }}</div>
          </div>
        </el-col>
      </el-col>
      <el-col
        v-show="innerWidthType === 'xs' && bottomItemImg && bottomItemFont"
        :span="22"
        class="container-items"
      >
        <el-col v-if="bottomItemImg" :span="24" class="container-items-img">
          <el-image
            :src="bottomItemImg"
            alt="公司简介中药团队"
            :preview-src-list="[bottomItemImg]"
            lazy
          />
        </el-col>
        <el-col
          v-if="bottomItemFont"
          :span="24"
          class="container-items-font-phone"
        >
          <div v-for="(item, index) in bottomItemFont" :key="index" class="bM">
            <span>{{ item.main }}</span>
            <div class="container-items-font-content">{{ item.content }}</div>
          </div>
        </el-col>
      </el-col>

      <el-col
        v-show="innerWidthType !== 'sm' && innerWidthType !== 'xs'"
        :span="22"
      >
        <timeLine />
      </el-col>
    </el-row>

    <videoDialog ref="videoDialog" />
  </div>
</template>

<script>
import API from '@/api/service'
import timeLine from '@/components/timeLine.vue'
import videoDialog from './components/videoDialog.vue'

export default {
  name: 'Home',
  components: {
    timeLine,
    videoDialog
  },
  data() {
    return {
      contentOneInfoBottom: null,
      contentTwoInfoBottom: null,
      innerWidthType: '',
      litterHeight: 150,
      topItemImg: '',
      topItemFont: {},
      bottomItemImg: '',
      bottomItemFont: [],
      nineGridData: [],
      phoneSearchHeight: 0
    }
  },
  created() {
    this.getNineGridDataList()
    this.getBigBannerDataList()
  },
  mounted() {
    this.getInnerWidthType()
    window.addEventListener('resize', () => {
      this.getInnerWidthType()
    })
    window.addEventListener('scroll', () => {
      this.setContentFix()
    })
  },
  destroyed() {
    window.removeEventListener('resize', () => {
      this.getInnerWidthType()
    })
    window.removeEventListener('scroll', () => {
      this.setContentFix()
    })
  },
  methods: {
    getInnerWidthType() {
      if (window.innerWidth >= 1920) {
        this.innerWidthType = 'xl'
      } else if (window.innerWidth >= 1200) {
        this.innerWidthType = 'lg'
      } else if (window.innerWidth >= 992) {
        this.innerWidthType = 'md'
      } else if (window.innerWidth > 768) {
        this.innerWidthType = 'sm'
      } else {
        this.innerWidthType = 'xs'
      }
      if (
        this.innerWidthType === 'sm' ||
        this.innerWidthType === 'xs' ||
        this.innerWidthType === 'md'
      ) {
        setTimeout(() => {
          if (
            this.innerWidthType === 'sm' ||
            this.innerWidthType === 'xs' ||
            this.innerWidthType === 'md'
          ) {
            if (this.$refs.litterImg) {
              this.litterHeight = this.$refs.litterImg[0].$el.clientHeight
            }
          }
        }, 560)
      }
      this.$nextTick(() => {
        if (this.$refs.contentOneInfo) {
          this.contentOneInfoBottom = window.getComputedStyle(
            this.$refs.contentOneInfo.$el
          ).bottom
        }
        if (this.$refs.contentTwoInfo) {
          this.contentTwoInfoBottom = window.getComputedStyle(
            this.$refs.contentTwoInfo.$el
          ).bottom
        }
      })
    },
    setContentFix() {
      if (
        this.$refs.contentOne &&
        this.$refs.contentTwo &&
        this.$refs.contentOneImg &&
        this.$refs.contentTwoImg
      ) {
        // one
        var contentHeightOne = this.$refs.contentOne.$el.getBoundingClientRect()
          .top
        var contentOneInfoBottomNum = Number(
          this.contentOneInfoBottom.substring(
            0,
            this.contentOneInfoBottom.length - 2
          )
        )
        var oneBottom = Number(
          `-${this.$refs.contentOneImg.$el.clientHeight -
            contentOneInfoBottomNum}`
        )
        // two
        var contentHeightTwo = this.$refs.contentTwo.$el.getBoundingClientRect()
          .top
        var contentTwoInfoBottomNum = Number(
          this.contentTwoInfoBottom.substring(
            0,
            this.contentTwoInfoBottom.length - 2
          )
        )
        var twoBottom = Number(
          `-${this.$refs.contentTwoImg.$el.clientHeight -
            contentTwoInfoBottomNum}`
        )
      }

      if (contentHeightOne < 0 && contentHeightOne > oneBottom) {
        if (this.$refs.contentOneInfo) {
          this.$refs.contentOneInfo.$el.style.bottom = `${contentOneInfoBottomNum -
            Number(contentHeightOne)}px`
        }
      } else {
        if (this.$refs.contentOneInfo) {
          this.$refs.contentOneInfo.$el.style.bottom = this.contentOneInfoBottom
        }
      }
      if (contentHeightTwo < 0 && contentHeightTwo > twoBottom) {
        if (this.$refs.contentTwoInfo) {
          this.$refs.contentTwoInfo.$el.style.bottom = `${contentTwoInfoBottomNum -
            Number(contentHeightTwo)}px`
        }
      } else {
        if (this.$refs.contentTwoInfo) {
          this.$refs.contentTwoInfo.$el.style.bottom = this.contentTwoInfoBottom
        }
      }
    },
    getNineGridDataList() {
      API.getBannerList({ banner_cat_id: 7 }).then(res => {
        const data = []
        res.data.map(item => {
          item.remark = JSON.parse(item.remark)
          item.remark.img = item.url
          item.remark.isShadow = true
          const arr = []
          for (let i = 0; i < item.remark.infoCh.length; i += 2) {
            arr.push(item.remark.infoCh.substr(i, 2))
          }
          item.remark.infoCh = arr.join('<br>')
          data.push(item.remark)
        })
        this.nineGridData = data
      })
    },
    getBigBannerDataList() {
      API.getBannerList({ banner_cat_id: 8 }).then(res => {
        res.data.map(item => {
          this[item.name] = item.url
          this[item.title] = JSON.parse(item.remark)
        })
      })
    },
    setHeight() {
      this.$parent.getHeightList()
    },
    setShadow(index) {
      setTimeout(() => {
        this.nineGridData.map(item => {
          item.isShadow = true
          item.showDetail = false
        })
        this.nineGridData[index].isShadow = false
        this.nineGridData[index].showDetail = true
      }, 0)
    },
    closeShadow() {
      setTimeout(() => {
        this.nineGridData.map(item => {
          item.isShadow = true
          item.showDetail = false
        })
      })
    },
    setPhoneSearchHeight(data) {
      this.phoneSearchHeight = data
    },
    openVideo() {
      this.$refs.videoDialog.open()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/home/xl.scss";
@media screen and (max-width: 1920px) {
  @import "@/assets/css/home/lg.scss";
}
@media screen and (max-width: 1200px) {
  @import "@/assets/css/home/md.scss";
}
@media screen and (max-width: 992px) {
  @import "@/assets/css/home/sm.scss";
}
@media screen and (max-width: 768px) {
  @import "@/assets/css/home/xs.scss";
}
</style>



// WEBPACK FOOTER //
// src/view/home.vue